import React from 'react';
export function HeroSection() {
  return <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 pb-8" data-id="element-3894">
      <div className="grid md:grid-cols-2 gap-8 items-center mb-8" data-id="element-3895">
        <div className="flex justify-center md:justify-start" data-id="element-3896">
          <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/LOGOS/Spinner%20Logo.jpg" alt="Spinner Logo" className="block h-24 md:h-32 w-auto object-contain" data-id="element-3897" />
        </div>
        <div className="flex justify-center md:justify-end" data-id="element-3898">
          <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/SPINNER/Turning%20Ultra-Precision.png800x800.png" alt="Ultra-Precision Turning" className="block max-h-[400px] w-auto object-contain" data-id="element-3899" />
        </div>
      </div>

      <div className="bg-[#0077B6] text-white py-6 px-8 rounded-xl shadow-md text-center md:text-left" data-id="element-3900">
        <h1 className="text-3xl md:text-4xl font-bold mb-2" data-id="element-3901">
          Ultra-Precision Turning
        </h1>
        <p className="text-lg md:text-xl text-white/90" data-id="element-3902">
          Ultra-precision lathes for hard turning and more
        </p>
      </div>
    </div>;
}